import React from 'react';
import { ArrowLeft } from '@phosphor-icons/react';
import { Button } from '../ui/button';

/**
 * The 2.0 page title: a short ceremonial heading in pale gold, a quiet line
 * under it, and a gold hairline. A back control only on child screens -- a
 * primary destination is reached from the navigation and has nowhere "back"
 * to go.
 */
const PageHeader = ({ title, subtitle, onBack, actions, children }) => (
  <header className="relative px-14 pt-4 pb-3 text-center">
    {onBack && (
      <Button
        variant="ghost"
        size="touch-icon"
        onClick={onBack}
        aria-label="Back"
        className="absolute left-2 top-2.5"
        data-testid="page-back"
      >
        <ArrowLeft className="w-5 h-5" />
      </Button>
    )}
    <h1
      className="font-heading text-xl tracking-[0.16em] uppercase leading-tight"
      style={{ color: 'hsl(var(--gold-pale))' }}
    >
      {title}
    </h1>
    {subtitle && (
      <p className="mt-1 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{subtitle}</p>
    )}
    {actions && <div className="absolute right-2 top-2.5 flex items-center">{actions}</div>}
    {children}
    <div className="mx-auto mt-3 h-px max-w-md" style={{ background: 'hsl(var(--gold) / 0.25)' }} aria-hidden="true" />
  </header>
);

export default PageHeader;
